<template> 
<div id="main">
<!--div style="color:white;background:url(image/bg6.jpg);background-position:center center;">
  <div class="content" align="center">
    <br><h1>更受欢迎的 ERP 系统</h1>
    <p class="textBig" style="display:inline-block;*display:inline;*zoom:1;margin:0px 3px;">功能更多</p> &bull; <p class="textBig" style="display:inline-block;*display:inline;*zoom:1;margin:0px 3px;">流程更强</p> &bull; <p class="textBig" style="display:inline-block;*display:inline;*zoom:1;margin:0px 3px;">界面更佳</p> &bull; <p class="textBig" style="display:inline-block;*display:inline;*zoom:1;margin:0px 3px;">口碑更好</p>
    <br><br>
    <img class="contentImage" alt="ERP体验" src="/static/picture/demo1.png">
  </div>
</div-->

<div class="contentContainer" style="height: 300px">
  <div class="content" align="center">
    <div class="block3">
      <h2 class="small">电脑用户体验</h2>多业务并行界面模式（用户名和密码:admin）<br><br>
      <a class="button2 textMiddle" style="width:60%;" href="http://www.myferp.com:8077/?dbName=haichi"  target="_blank"> WEB版登录</a> 
    </div> <div class="block3" style="height: 300px">
      <h2 class="small">手机用户体验</h2>优化小屏幕界面，手机扫码体验<br><br>
	  <div id="qrcode" style="width:20px;height:20px; display:inline-block;width:50%;"></div>
      <!--a style="display:inline-block;width:40%;color:white;font-size:12px;text-decoration:none;background-color:black;border-radius:10px;padding:20px 0px;margin-right:5%;" href="javascript:;"><img src="/static/picture/apple.png" border="0"><br>手机上点击安装<br>iPhone App</a><a style="display:inline-block;width:40%;color:white;font-size:12px;text-decoration:none;background-color:#97c024;border-radius:10px;padding:20px 0px;" href="javascript:;"><img src="/static/picture/android.png" border="0"><br>手机上点击安装<br>Android App</a-->
    </div>
    <!--div class="seperator"></div-->
    <!--div class="block2">
      <a href="play.html" target="_blank"><div class="textBig">&#9658; 视频体验：5分钟设计一个流程</div><img src="/static/picture/bpm.png" class="contentImage"></a>
    </div><div class="block2">
      <a href="play.html" target="_blank"><div class="textBig">&#9658; 视频体验：10分钟搭建一个模块</div><img src="/static/picture/dev.png" class="contentImage"></a>
    </div-->
    <br><br>
    
  </div>
</div>

<div class="contentContainer" id="demoFlow">
  <div class="content">
    <h2 align="center">【专题体验】<span class="highlight3">100多种电子流程</span></h2>
    <div class="seperator" id="demoFlow1"></div>
    <div class="block2">
      <img class="contentImage" src="/static/picture/wdzm_03.png">
    </div><div class="block2">
      <br><h3>全面流程化驱动</h3><br>
      <img src="/static/picture/item.gif" border="0"> 计划、任务、报告等 3大 目标类流程<br>
      <img src="/static/picture/item.gif" border="0"> 新闻公告、文档管理等 5大 信息类流程<br>
      <img src="/static/picture/item.gif" border="0"> 会议室、车辆、资产、用品等 18种 行政类流程<br>
      <img src="/static/picture/item.gif" border="0"> 招聘、考勤、关怀、考核等 18种 人事类流程<br>
      <img src="/static/picture/item.gif" border="0"> 费用、票据、资金等 8种 财务类流程<br>
      <img src="/static/picture/item.gif" border="0"> 客户、项目、库存、采购等 26种 业务类流程<br>
      <img src="/static/picture/item.gif" border="0"> 快速配置成百上千种、个性化的电子流程
    </div>
    <div class="seperator" id="demoFlow2"></div>
    <div class="block2" align="right">
      <br><h3>电子单据全自动流转</h3><br>
      根据预定的业务流程图自动流转 <img src="/static/picture/item.gif" border="0"><br>
      支持顺序处理、分支处理、多人会签等 <img src="/static/picture/item.gif" border="0"><br>
      无缝衔接多个办公环节和处理步骤 <img src="/static/picture/item.gif" border="0"><br>
      系统自动向后续处理人发送通知和提醒 <img src="/static/picture/item.gif" border="0"><br>
      全程记录并显示每一步的处理过程 <img src="/static/picture/item.gif" border="0">
    </div><div class="block2" align="right">
      <img class="contentImage" src="/static/picture/cwzx_03.png">
    </div>
    <div class="seperator" id="demoFlow3"></div>
    <div class="block2">
      <img class="contentImage" src="/static/picture/wdsw_02.png">
    </div><div class="block2">
      <br><h3>主动通知和提醒</h3><br>
      <img src="/static/picture/item.gif" border="0"> 流程运转到哪一步，主动给予桌面通知<br>
      <img src="/static/picture/item.gif" border="0"> 流程运转到哪一步，在手机App端实时提醒<br>
      <img src="/static/picture/item.gif" border="0"> 在我的桌面上罗列待办事宜，实现“事找人”<br>
      <img src="/static/picture/item.gif" border="0"> 不同的事务状态，给予不同的图标和颜色<br>
      <img src="/static/picture/item.gif" border="0"> 实时统计并以数字显示待办事宜的数量
    </div>
    <div class="seperator" id="demoFlow4"></div>
    <div class="block2" align="right">
      <br><h3>辅助填单和规范运作</h3><br>
      自动带出当前用户名、所属部门和当天日期 <img src="/static/picture/item.gif" border="0"><br>
      下拉选取可能的选项，减少用户输入和失误 <img src="/static/picture/item.gif" border="0"><br>
      能够模糊查找，获得员工、资产和用品等信息 <img src="/static/picture/item.gif" border="0"><br>
      自动验证表单上的数字、金额、日期等 <img src="/static/picture/item.gif" border="0"><br>
      自动计算累计数量或金额，并能转换为大写 <img src="/static/picture/item.gif" border="0">
    </div><div class="block2" align="right">
      <img class="contentImage" src="/static/picture/xzgl_02.png">
    </div>
  </div>
</div>

<div class="contentContainer" id="demoMobile">
  <div class="content">
    <h2 align="center">【专题体验】<span class="highlight3">24小时移动访问</span></h2>
    <div class="seperator" id="demoMobile1"></div>
    <div class="block2">
      <img class="contentImage" src="/static/picture/mobile.png">
    </div><div class="block2">
      <br><h3>24小时在线协作</h3><br>
      <img src="/static/picture/item.gif" border="0"> 内核支持移动办公，数据流程实时同步<br>
      <img src="/static/picture/item.gif" border="0"> PC电脑、笔记本、平板、手机四屏畅通<br>
      <img src="/static/picture/item.gif" border="0"> 随时随地收发邮件、安排任务、审批流程等<br>
      <img src="/static/picture/item.gif" border="0"> 及时查阅新闻公告，分享知识并互动交流<br>
      <img src="/static/picture/item.gif" border="0"> 加速企业办公和协作，业务快人一步！
    </div>
    <div class="seperator" id="demoMobile2"></div>
    <div class="block2" align="right">
      <br><h3>随时随地移动审批</h3><br>
      100多种电子流程，全部可以在手机上审批 <img src="/static/picture/item.gif" border="0"><br>
      即时获得提醒，利用碎片时间处理业务 <img src="/static/picture/item.gif" border="0"><br>
      完整显示单据的明细、流程图和处理过程 <img src="/static/picture/item.gif" border="0"><br>
      完整的数据，帮助您做出正确决策 <img src="/static/picture/item.gif" border="0"><br>
      加速您的业务处理，不耽误一项工作 <img src="/static/picture/item.gif" border="0">
    </div><div class="block2" align="right">
      <img class="contentImage" src="/static/picture/mobile5.png">
    </div>
    <div class="seperator" id="demoMobile3"></div>
    <div class="block2">
      <img class="contentImage" src="/static/picture/mobile4.png">
    </div><div class="block2">
      <br><h3>一线人员手机下单</h3><br>
      <img src="/static/picture/item.gif" border="0"> 一线销售人员，在手机上直接下单<br>
      <img src="/static/picture/item.gif" border="0"> 请求协助、合同审核、申请开票、客户服务 &middot;&middot;&middot;&middot;&middot;&middot;<br>
      <img src="/static/picture/item.gif" border="0"> 一线工程人员，在手机上直接下单<br>
      <img src="/static/picture/item.gif" border="0"> 采购申请、出差申请、付款申请、汇报进度 &middot;&middot;&middot;&middot;&middot;&middot;<br>
      <img src="/static/picture/item.gif" border="0"> 支持手机拍照，并附加到流程单中
    </div>
    <div class="seperator" id="demoMobile4"></div>
    <div class="block2" align="right">
      <br><h3>外勤跟踪和定位</h3><br>
      手指一点轻松定位，外勤人员移动考勤 <img src="/static/picture/item.gif" border="0"><br>
      基于地理位置，汇总形成工作轨迹 <img src="/static/picture/item.gif" border="0"><br>
      帮助主管跟踪和了解外勤工作动态 <img src="/static/picture/item.gif" border="0"><br>
      避免外勤人员脱岗或者挪用工作时间 <img src="/static/picture/item.gif" border="0"><br>
      帮助人事专员获取考勤数据并统计 <img src="/static/picture/item.gif" border="0">
    </div><div class="block2" align="center">
      <img class="contentImage" src="/static/picture/mobile8.png">
    </div>
  </div>
</div>

<div class="contentContainer" id="demoUI">
  <div class="content">
    <h2 align="center">【专题体验】<span class="highlight3">N多项创新设计</span></h2>
    <div class="seperator" id="demoUI1"></div>
    <div class="block2">
      <img class="contentImage" src="/static/picture/workflow.png">
    </div><div class="block2">
      <br><h3>平面化、纸张式界面</h3><br>
      <img src="/static/picture/item.gif" border="0"> 平面化设计，聚焦业务和工作本身<br>
      <img src="/static/picture/item.gif" border="0"> 模拟纸张铺于桌面的感觉，所见即所得<br>
      <img src="/static/picture/item.gif" border="0"> 精致的电子单据，能够直接打印<br>
      <img src="/static/picture/item.gif" border="0"> 大量采用树形结构，轻松导航或分类<br>
      <img src="/static/picture/item.gif" border="0"> 无需专门培训，短时间学会使用
    </div>
    <div class="seperator" id="demoUI2"></div>
    <div class="block2" align="right">
      <br><h3>飞快的界面响应速度</h3><br>
      C++开发的核心引擎，具有更高的系统性能 <img src="/static/picture/item.gif" border="0"><br>
      简洁精致的界面，在两三秒内即可呈现 <img src="/static/picture/item.gif" border="0"><br>
      精心设计的导航和操作，大幅减少点击次数 <img src="/static/picture/item.gif" border="0"><br>
      为您节约每一秒时间，更多地思考业务本身 <img src="/static/picture/item.gif" border="0"><br>
      为您节省购买服务器和网络带宽的成本 <img src="/static/picture/item.gif" border="0">
    </div><div class="block2" align="right">
      <img class="contentImage" src="/static/picture/easy.png">
    </div>
    <div class="seperator" id="demoUI3"></div>
    <div class="block2">
      <img class="contentImage" src="/static/picture/wdsw_01.png">
    </div><div class="block2">
      <br><h3>辅助填写业务单据</h3><br>
      <img src="/static/picture/item.gif" border="0"> 自动带出当前用户名、所属部门和当天日期<br>
      <img src="/static/picture/item.gif" border="0"> 下拉选取可能的选项，减少用户输入和失误<br>
      <img src="/static/picture/item.gif" border="0"> 能够模糊查找，获得员工、资产和用品等信息<br>
      <img src="/static/picture/item.gif" border="0"> 自动验证表单上的数字、金额、日期等<br>
      <img src="/static/picture/item.gif" border="0"> 自动计算累计数量或金额，并能转换为大写
    </div>
    <div class="seperator" id="demoUI4"></div>
    <div class="block2" align="right">
      <br><h3>单据关联和数据同步</h3><br>
      工作计划、任务、报告等表单互相关联 <img src="/static/picture/item.gif" border="0"><br>
      在不同单据间传递数据，减少用户操作时间 <img src="/static/picture/item.gif" border="0"><br>
      领用行政资产时，自动同步资产状态信息 <img src="/static/picture/item.gif" border="0"><br>
      采购或领用办公用品后，自动增减用品库存 <img src="/static/picture/item.gif" border="0"><br>
      费用审批通过后，自动生成财务支出项 <img src="/static/picture/item.gif" border="0">
    </div><div class="block2" align="right">
      <img class="contentImage" src="/static/picture/mbgl_01.png">
    </div>
  </div>
</div>

 

</div>
 
</template>
 

<script>
 
export default {
 
        data () {
            return {
			  
            }
        },
		mounted(){
						 $("#qrcode").empty();
						 $('#qrcode').qrcode({
						 render:"canvas",
						 width:160,
						 height: 160,
						 text: 'http://www.myferp.com/thailand/index.html'
						 
						 });
		},
}
</script>
		


// WEBPACK FOOTER //
// src/components/demo.vue